var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "slide-fade" }, on: { "after-enter": _vm.afterEnter } },
    [
      _c(
        "el-card",
        {
          ref: "slide",
          staticClass: "slide-detail-card-container",
          style: { "z-index": _vm.zIndex },
          attrs: { id: "slide", "body-style": _vm.bodyStyle },
        },
        [
          _vm.showClose
            ? _c("el-button", {
                staticClass: "close-btn xr-btn--orange",
                attrs: { type: "primary", icon: "el-icon-close" },
                on: { click: _vm.close },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                "append-to-body": true,
                "close-on-click-modal": false,
                "custom-class": "no-padding-dialog",
                title: "提示",
                top: "30vh",
                width: "420px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "el-message-box__container",
                  staticStyle: { padding: "10px 15px 15px" },
                },
                [
                  _c("div", {
                    staticClass: "el-message-box__status el-icon-warning",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "el-message-box__message" }, [
                    _vm._v("确定离开？正在编辑的内容将会丢失。"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.dialogSure },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }